/* import __COLOCATED_TEMPLATE__ from './advanced-invite-details.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();